import React from "react";
import { Link } from "gatsby";
import { Mark } from "./Icons";
import site from "../data/site";

/**
 * Wordmark lockup. `tone="light"` for use over navy or photography.
 */
export default function Logo({ tone = "dark", size = 1, to = "/" }) {
  const color = tone === "light" ? "var(--on-navy)" : "var(--navy)";
  const [first, ...restWords] = site.brand.split(" ");
  const rest = restWords.join(" ");
  return (
    <Link to={to} aria-label={`${site.brand} home`} style={{ display: "inline-flex", alignItems: "center", gap: 12 * size, color }}>
      <Mark size={30 * size} />
      <span style={{ display: "grid", lineHeight: 1 }}>
        <span style={{ fontFamily: "var(--serif)", fontSize: `${1.32 * size}rem`, letterSpacing: "-0.01em", fontWeight: 500 }}>{first}</span>
        <span style={{ fontFamily: "var(--sans)", fontSize: `${0.6 * size}rem`, letterSpacing: "0.22em", textTransform: "uppercase", fontWeight: 700, color: "var(--brass)", marginTop: 4 * size }}>{rest}</span>
      </span>
    </Link>
  );
}
